var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("AccountLink"),
      _vm._v(" "),
      _c("AccountLink", {
        attrs: {
          "link-text": "My Account - Sign in or Register",
          "is-mobile-only": "",
          "sign-in-nudge-experience": _vm.signInNudgeExperience,
          "mounting-point-selector": "[data-js='mobile-nav-login-link']",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }